import React from "react";

// ----> REACT ROUTER DOM IMPORTATION
import { Route, Routes } from "react-router-dom";

// ----> VIEWS COMPONENTS
import { HomeView } from "../views/home/HomeView";
import { ProtectedRoutes } from "../auth/protected-route/ProtectedRoutes";
import { DashBoardCustomer } from "../views/dashboard/DashBoardCustomer";
import { NewCallComp } from "../views/case-report/NewCallComp";
import { TrackComp } from "../views/track-case/TrackComp";
import { PageNotFound } from "../views/page-not-found/PageNotFound";
import { SignUpForm } from "../views/sign-up/SignUpForm";
import { EmailValidation } from "../views/email-validation/EmailValidation";

// ----> USER PROVIDER IMPORTATION
import { UserProvider } from "../context/UserProvider.jsx";
import { LangProvider } from "../context/LangProvider.jsx";
import { ResetPasswdView } from "../views/reset-password/ResetPasswdView";
import { ContactsView } from "../views/contacts/ContactsView";


export const AppRouter = () => {
  return (
    <>
      <UserProvider>
        <LangProvider>
          <Routes>
            <Route path="/" element={<HomeView />} />
            <Route path="/sign-up" element={<SignUpForm />} />
            <Route path="*" element={<PageNotFound />} />
            <Route path="/action/email/validation/:code" element={<EmailValidation />} />
            <Route path="/reset-passwd/:code" element={<ResetPasswdView />} />

            {/* RUTA PROTEGIDA */}
            {/* <UserProvider> */}
            <Route element={<ProtectedRoutes />}>
              <Route path="create-case" element={<NewCallComp />} />
              <Route path="dashboard" element={<DashBoardCustomer />} />
              <Route path="tracking-case" element={<TrackComp />} />

              <Route path="contacts" element={<ContactsView />} />
            </Route>
            {/* </UserProvider> */}
          </Routes>
        </LangProvider>
      </UserProvider>

    </>
  );
};